import { Flex, Text, Box } from "@chakra-ui/react"
import { RootState, useAppSelector } from "../../../store";
import { formatDate } from "../../../helpers/formatDate";

export const HistoryCustomerBlock = () => {
    const { currentCustomer } = useAppSelector(
        (state: RootState) => state.customers
    );

    // Функция для преобразования текста с переносами строк в HTML
    const formatTextToHTML = (text: string) => {
        return text.replace(/\n/g, '<br>');
    };

    return (
        <Flex gap="24px" flexDirection="column" borderLeft="1px solid grey" maxH="70vh" overflowY="auto" paddingLeft="36px">
            <Text fontWeight={500}>История взаимодействия</Text>
            <Flex flexDirection="column" gap="16px">
                {currentCustomer?.activities?.map((activity, index) => (
                    <Flex key={index} flexDirection="column" borderBottom="1px solid grey" paddingBottom="16px">
                        <Text fontWeight={600} marginBottom="8px">{formatDate(activity.created_at, true)}</Text>
                        <Box dangerouslySetInnerHTML={{ __html: formatTextToHTML(activity.action) }} />
                    </Flex>
                ))}
            </Flex>
        </Flex>
    )
}